module.exports = __webpack_public_path__ + "media/images/triangle--down-f86ada8256696c8a2c0ea474800b30ba.png";